<div *ngIf="params.data && !params.data.editable">
    {{params.data.displayorder}}
</div>
<div *ngIf="params.data && params.data.editable">
    <textarea type="text" [(ngModel)]="params.data.displayorder" style="width:100%;"
    placeholder="Place your text here" rows="2"></textarea>
</div>
